import {  FC,useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import {  useLocation, useHistory } from "react-router-dom";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import css from "../../../smallnation/assets/custom.css";
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
//import publichttp from "./http-public";
import { Link } from 'react-router-dom';

const Mergewithcompany: FC = () => {
      const intl = useIntl();
      const red="red";
      const [companyList, setCompanyList] = useState([]);
      const [query, setQuery] = useState("");
      //const [sourceCompanyId, setSourceCompanyId] = useState("");
      //const [destCompanyId, setDestCompanyId] = useState("");
      const [sourceCompanyId, setSourceCompanyId] =  useState<any>([]);
      const [destCompanyId, setDestCompanyId] = useState<any>([]);
      let history = useHistory();

      const [logourlDisplay, setLogoUrlDisplay] = useState('');
      const [employeeCount, setemployeeCount] = useState('');
      const [companyName, setcompanyName] = useState('');
      const [companyAddress, setcompanyAddress] = useState('');
      const [adminName, setadminname] = useState('');
      const [adminEmail, setadminemail] = useState('');
      const [totalActiveJobs, setTotalItems] = useState(0);
      const [totalPendingJobs, setTotalPendingItems] = useState(0);
      const [userList, setUsersList] = useState([]);

      const [destcompanyName, setdestcompanyName] = useState('');
      const [destlogourlDisplay, setDestLogoUrlDisplay] = useState('');
      const [destcompanyAddress, setdestcompanyAddress] = useState('');
      const [destemployeeCount, setdestemployeeCount] = useState('');
      const [destAdminName, setdestadminname] = useState('');
      const [destAdminEmail, setdestadminemail] = useState('');
      const [desttotalActiveJobs, setdestTotalItems] = useState(0);
      const [desttotalPendingJobs, setdestTotalPendingItems] = useState(0);
      const [destuserList, setDestUsersList] = useState([]);
      
      
      const {
         register,
         formState: { errors },
         handleSubmit
       } = useForm({
         criteriaMode: "all",mode: "onBlur" 
       }); 

      function validateCheck() {
        //alert("test");
      }

      const animatedComponents = makeAnimated();

      const submitValue=()=>
      {
        var chkSourceCompanyId = sourceCompanyId.companyId;
        var chkDestCompanyId = destCompanyId.companyId;
       // alert(chkSourceCompanyId+"  "+chkDestCompanyId);
        var validateEditorTxt = 1;
        if(chkSourceCompanyId == "" || typeof(chkSourceCompanyId) == "undefined"){
          $("#sourcecompanyValidMsg").show();
          $(window).scrollTop($('#sourcecompanyValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#sourcecompanyValidMsg").hide();
        }

        if(chkDestCompanyId == "" || typeof(chkDestCompanyId) == "undefined"){
          $("#destinationcompanyValidMsg").show();
          $(window).scrollTop($('#destinationcompanyValidMsg').position().top);
          validateEditorTxt = 0;
        }else {
          $("#destinationcompanyValidMsg").hide();
        }

        if(chkSourceCompanyId == chkDestCompanyId)
        {
          $("#mergecompanyfailMessageDuplicate").show();
          validateEditorTxt = 0;
        }else{
          $("#mergecompanyfailMessageDuplicate").hide();
        }

        /*
        if ($('#sourcecompany').val() == "") {
          $("#sourcecompanyValidMsg").show();
          $(window).scrollTop($('#sourcecompanyValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#sourcecompanyValidMsg").hide();
        }

        if ($('#destinationcompany').val() == "") {
          $("#destinationcompanyValidMsg").show();
          $(window).scrollTop($('#destinationcompanyValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#destinationcompanyValidMsg").hide();
        }
        */

        if (validateEditorTxt == 0) {
          return false;
        }
    
    
        const requestObject =
        {
          //"sourceCompanyId":$('#sourcecompany').val(),
          //"DestinationCompanyId":$('#destinationcompany').val()
          "sourceCompanyId":chkSourceCompanyId,
          "destinationCompanyId":chkDestCompanyId
        }

       
        //var accessTokenIn=sessionStorage.getItem("adminAccToken");
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };
       // console.log(requestObject); return false;
        services.adminMergeCompanies(requestOptions).then((res) => 
        {    
          //history.push('/companydirectory'); 
          if (res.code == '200') {
            $("#mergecompanysuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#mergecompanysuccessMessage").slideUp(2500);
            });
            setTimeout(() => {
              history.push('/companyDetails?companyId=' + chkDestCompanyId+'&tab='+2); 
              
            }, 1000);
          }


        });


       
      }


      function getAdminCompaniesList() {
        var searchTxt = "";//$('#search_input').val();
        var statuschk = 'published';
        var sortBy = '';
        var sortDir = '';
        var itemsPerPage = '15000';
        var pageNumberV = '1';
        var siteIdv = '2'
        //alert("309")
        services.adminGetCompanyList(siteIdv, itemsPerPage, pageNumberV, searchTxt, statuschk, sortBy, sortDir).then((res) => {
          console.log("#######################");
          //console.log(JSON.stringify(res));
          //alert("314")
          if (res.data) {
           // console.log(JSON.stringify(res));    
            setCompanyList(res.data.content);
          }
    
    
        });
      }

  const loadCompanydetails = (selectedval) => {
    setSourceCompanyId(selectedval)
    var companyid_selected = selectedval.companyId;
    services.adminGetCompanyProfile(companyid_selected).then((res) => {
      if (res.data) {
        $('#soucecompany').show();
        console.log(res);
        var companyProfile = res.data;
        setcompanyName(companyProfile.name);
        setemployeeCount(companyProfile.employeeCount);
        setLogoUrlDisplay(companyProfile.logoUrl);
        var companyAddressval = companyProfile.address1+', '+companyProfile.address2+', '+companyProfile.city+', '+companyProfile.state+', '+companyProfile.zip;
        setcompanyAddress(companyAddressval);
        setadminname(companyProfile.firstName+' '+companyProfile.lastName);
        setadminemail(companyProfile.email);

        getCurrent(companyid_selected,'published','','15000','1','postedDate','desc');
        getCurrent(companyid_selected,'pending','','15000','1','postedDate','desc');
        filterUserList(companyid_selected);
      }
    });
  }

  const loadDestCompanydetails = (selectedval) => {
    setDestCompanyId(selectedval)
    var destcompanyid_selected = selectedval.companyId;
    services.adminGetCompanyProfile(destcompanyid_selected).then((res) => {
      if (res.data) {
        $('#destinationcompanydetails').show();
        console.log(res);
        var destcompanyProfile = res.data;
        setdestcompanyName(destcompanyProfile.name);
        setdestemployeeCount(destcompanyProfile.employeeCount);
        setDestLogoUrlDisplay(destcompanyProfile.logoUrl);
        var destcompanyAddressval = destcompanyProfile.address1+', '+destcompanyProfile.address2+', '+destcompanyProfile.city+', '+destcompanyProfile.state+', '+destcompanyProfile.zip;
        setdestcompanyAddress(destcompanyAddressval);
        setdestadminname(destcompanyProfile.firstName+' '+destcompanyProfile.lastName);
        setdestadminemail(destcompanyProfile.email);
            
        getdestCurrent(destcompanyid_selected,'published','','15000','1','postedDate','desc');
        getdestCurrent(destcompanyid_selected,'pending','','15000','1','postedDate','desc');
        filterDestUserList(destcompanyid_selected);
      }
    });
  }

  function getCurrent(companyId,status,title,ITEMS_PER_PAGE,pageNumber,sortBy,sortDir){
        var title:any = '';
        var sortByInput = sortBy;//"postedDate";
        var sorDirInput = sortDir;//"desc";
        var siteId = 2;
        
        services.getCompanyJobExpiredCurrent(companyId,status,title,ITEMS_PER_PAGE,pageNumber,sortByInput,sorDirInput,siteId).then((res) => 
        {
          if(status == 'published'){
            setTotalItems(res.data.totalElements); 
          }  
          else{
            setTotalPendingItems(res.data.totalElements); 
          }
                      
        });
    }

    function getdestCurrent(companyId,status,title,ITEMS_PER_PAGE,pageNumber,sortBy,sortDir){
      var title:any = '';
      var sortByInput = sortBy;//"postedDate";
      var sorDirInput = sortDir;//"desc";
      var siteId = 2;
      
      services.getCompanyJobExpiredCurrent(companyId,status,title,ITEMS_PER_PAGE,pageNumber,sortByInput,sorDirInput,siteId).then((res) => 
      {
        if(status == 'published'){
          setdestTotalItems(res.data.totalElements); 
        }  
        else{
          setdestTotalPendingItems(res.data.totalElements); 
        }
                    
      });
  }

  function filterUserList(selectedcompanyId) {

    const requestObject = {

      "siteId": "2",
      "userType": "company",
      "searchTxt": "",
      "companyId": selectedcompanyId,
      "pageNumber": 1,
      "pageSize": 150
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getAdminUserList(requestOptions).then((res) => {
      console.log("#######################");
      console.log(res);
      if (res) {
        try {
          setUsersList(res.content);
        } catch (ex) {
          console.log("ex:" + ex);
        }

      }
      else {
        setUsersList([]);
      }


    });
  }  

  function filterDestUserList(selectedcompanyId) {

    const requestObject = {

      "siteId": "2",
      "userType": "company",
      "searchTxt": "",
      "companyId": selectedcompanyId,
      "pageNumber": 1,
      "pageSize": 150
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getAdminUserList(requestOptions).then((res) => {
      console.log("#######################");
      console.log(res);
      if (res) {
        try {
          setDestUsersList(res.content);
        } catch (ex) {
          console.log("ex:" + ex);
        }

      }
      else {
        setDestUsersList([]);
      }


    });
  } 

  function getDisplayRole(rolev) {
    if (rolev == "employerUser") {
      return "Company User";
    } else if (rolev == "employerAdmin") {
      return "Company Admin";
    }
    return "";
  }

  function getDisplayStatus(st) {
    if (st == "active") {
      return "Active";
    } else if (st == "inactive") {
      return "Inactive";
    } else if (st == "pending") {
      return "Active";
    }
    return "";
  }

      const loadOptionsSource =  (query, callback) => {
       // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());

       var result_set = '';
       var statuschk = 'published';
       var sortBy = '';
       var sortDir = '';
       var pageSize = '60';
       var pageNumber = '1';
       var siteId = '2'

       var queryval = query;
    var encoded_queryval = encodeURIComponent(queryval)

       var endpoint= process.env.REACT_APP_AWS_API+`adminGetCompanyList?siteId=`+siteId+`&status=`+statuschk+`&pageNumber=`+pageNumber+`&pageSize=`+pageSize+`&sortBy=`+sortBy+`&sortDir=`+sortDir+`&title=&searchTxt=`+encoded_queryval;

        fetch(endpoint).then(response => {
          response.json().then(data => {
              //console.log("202-->"+JSON.stringify(data));
              const results = data.content;

              var statuschkval = 'pending';
     
              var queryval = query;
              var encoded_queryval = encodeURIComponent(queryval)
     
              var endpoint= process.env.REACT_APP_AWS_API+`adminGetCompanyList?siteId=`+siteId+`&status=`+statuschkval+`&pageNumber=`+pageNumber+`&pageSize=`+pageSize+`&sortBy=`+sortBy+`&sortDir=`+sortDir+`&title=&searchTxt=`+encoded_queryval;
     
              fetch(endpoint).then(response => {
                response.json().then(data => {

                    const results2 = data.content;
                    console.log('************')
                    console.log(data.content);
                    const resultsetgroup = results.concat(results2);
                    callback(resultsetgroup);            
                });
          });
        });
      });

      };

      const loadOptionsDestin =  (query, callback) => {
        // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());
        var statuschk = 'published';
        var sortBy = '';
        var sortDir = '';
        var pageSize = '60';
        var pageNumber = '1';
        var siteId = '2'
 
        var queryval = query;
     var encoded_queryval = encodeURIComponent(queryval)
 
        var endpoint= process.env.REACT_APP_AWS_API+`adminGetCompanyList?siteId=`+siteId+`&status=`+statuschk+`&pageNumber=`+pageNumber+`&pageSize=`+pageSize+`&sortBy=`+sortBy+`&sortDir=`+sortDir+`&title=&searchTxt=`+encoded_queryval;
 
         fetch(endpoint).then(response => {
           response.json().then(data => {
             //console.log("202-->"+JSON.stringify(data));
             const results = data.content;
             //console.log(data.content);
             callback(results);            
           });
         });
 
       };

      const handleChange  = (selectedOption) => {
        console.log(selectedOption);
      }
      
      useEffect(() => {
        validateCheck();
        $('#soucecompany').hide();
        $('#destinationcompanydetails').hide();
       // getAdminCompaniesList();
     
        $('#mergecompanysuccessMessage').hide();
        $('#mergecompanyfailMessage').hide();
        $('#mergecompanyfailMessageDuplicate').hide();
        
        $('#sourcecompanyValidMsg').hide();
        $('#destinationcompanyValidMsg').hide();
      }, []);
      return (
        <>
          {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Merge Companies'})}</PageTitle> */}
          <form onSubmit={handleSubmit(submitValue)}>
          <div className="container">
               <div className="row">
               <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <div  className="alert alert-warning" role="alert">Caution: This will delete the "From" company from the system and this process is irreversible.</div>
                 
                 </div>
              </div>
                 </div>

                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Select Company to remove and merge data from</label>
               
                 </div>
                 {/* <AsyncSelect
                        cacheOptions
                        components={animatedComponents}
                       // getOptionLabel={(e) => e.name}
                       // getOptionValue={(e) => e.companyId}
                        getOptionLabel={(e) => e.title}
                        getOptionValue={(e) => e.socCode}
                        loadOptions={loadOptions}
                        onInputChange={(value) => setQuery(value)}
                        onChange={handleChange}
                    /> */}

                <AsyncSelect
                    cacheOptions
                    components={animatedComponents}                  
                    getOptionLabel={(e:any) => e.name}
                    getOptionValue={(e) => e.companyId}
                    loadOptions={loadOptionsSource}
                    onInputChange={(value) => setQuery(value)}
                   // onChange={handleChange}
                   onChange={(value) => loadCompanydetails(value)}
                />
                {/* 
                onChange={(value) => setSourceCompanyId(value)}
                <select className="form-select" id="sourcecompany" name="sourcecompany" aria-label="Select example">
                  <option selected value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId} >{data.name}</option>
                    ))}
                </select>*/}
                 <div id="sourcecompanyValidMsg" style={{color:red}} className="error">Company Name is required.</div>
              </div>
                 </div>

                 <div className="container" id="soucecompany">
          <div className="row">

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Company Name: <Link target="_blank" className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/companyDetails?companyId='+sourceCompanyId.companyId}>{companyName} </Link></label>
                </div>
                
              </div>
            </div>

           
            <div className="col-lg-2">
              <div className="mb-10" style={{position:"relative"}}>
                <div className="d-flex flex-column ">
                  <label className="  form-label ">Company Logo: {logourlDisplay ? <img src={logourlDisplay}  alt='' className="w-100 mt-4 p-2" /> : <b>Logo Not Available</b>}</label>
                </div>
              </div>
            </div>
            <div className="col-lg-4">

            </div>
            
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Address: </label>

                </div>
                <strong>{companyAddress}</strong>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Admin Name:</label>
                </div>
                <strong>{adminName}</strong>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Admin Email:</label>
                </div>
                <strong>{adminEmail}</strong>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">No of Active Jobs: <strong>{totalActiveJobs}</strong></label>
                </div>
                
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">No of Pending Jobs: <strong>{totalPendingJobs}</strong></label>
                </div>
                
              </div>
            </div>
           
            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" defaultValue="1" className="form-label">No of Employees: <strong>{employeeCount}</strong></label> 

                </div>
                
              </div>
            </div> */}

          </div>

          <div id="companyUsersDiv">
            <h3>Company Users</h3>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder text-muted'>
                  
                  <th className='min-w-150px'>Name</th>
                  <th className='min-w-140px'>Email</th>
                  <th className='min-w-120px'>User Role</th>
                  <th className='min-w-120px'>Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  userList.map((data, index) => (
                    <tr>
                      <td>
                         {(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName}
                      </td>

                      <td>
                        {(data.email=='' || data.email==null) ? '--' : data.email}
                      </td>
                     
                      <td>
                        {(data.roleName=='' || data.roleName==null) ? '--' : getDisplayRole(data.roleName)}
                      </td>

                      <td>
                        {(data.status=='' || data.status==null) ? '--' : getDisplayStatus(data.status)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

        </div>



                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <div className="alert alert-info" role="alert">This transfers all users, jobs & job applications from one company to another.</div>
                 
                 </div>
              </div>
                 </div>

                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Select Company to merge to</label>
               
                 </div>

                 <AsyncSelect
                    cacheOptions
                    components={animatedComponents}                  
                    getOptionLabel={(e:any) => e.name}
                    getOptionValue={(e) => e.companyId}
                    loadOptions={loadOptionsDestin}
                    onInputChange={(value) => setQuery(value)}
                    //onChange={handleChange}
                   onChange={(value) => loadDestCompanydetails(value)}
                />

                 {/* 
                 
                 onChange={(value) => setDestCompanyId(value)}
                 <select className="form-select" id="destinationcompany" name="destinationcompany" aria-label="Select example">
                  <option selected value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId} >{data.name}</option>
                    ))}
                </select> */}
                 <div id="destinationcompanyValidMsg" style={{color:red}} className="error">Company Name is required.</div>
              </div>
                 </div>


                 <div className="container" id="destinationcompanydetails">
          <div className="row">

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Company Name: <Link target='_blank' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/companyDetails?companyId='+destCompanyId.companyId}>{destcompanyName} </Link></label>
                </div>
                
              </div>
            </div>

            <div className="col-lg-2">
              <div className="mb-10" style={{position:"relative"}}>
                <div className="d-flex flex-column ">
                  <label className="  form-label ">Company Logo: {destlogourlDisplay ? <img src={destlogourlDisplay}  alt='' className="w-100 mt-4 p-2" /> : <b>Logo Not Available</b>}</label>
                </div>
              </div>
            </div>
            <div className="col-lg-4">

            </div>
            
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Address: </label>

                </div>
                <strong>{destcompanyAddress}</strong>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Admin Name:</label>
                </div>
                <strong>{destAdminName}</strong>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Admin Email:</label>
                </div>
                <strong>{destAdminEmail}</strong>
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">No of Active Jobs: <strong>{desttotalActiveJobs}</strong></label>
                </div>
                
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">No of Pending Jobs: <strong>{desttotalPendingJobs}</strong></label>
                </div>
                
              </div>
            </div>
           
            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" defaultValue="1" className="form-label">No of Employees: <strong>{destemployeeCount}</strong></label> 

                </div>
                
              </div>
            </div> */}

          </div>

          <div id="companyUsersDiv">
            <h3>Company Users</h3>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder text-muted'>
                  
                  <th className='min-w-150px'>Name</th>
                  <th className='min-w-140px'>Email</th>
                  <th className='min-w-120px'>User Role</th>
                  <th className='min-w-120px'>Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  destuserList.map((data, index) => (
                    <tr>
                      <td>
                         {(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName}
                      </td>

                      <td>
                        {(data.email=='' || data.email==null) ? '--' : data.email}
                      </td>
                     
                      <td>
                        {(data.roleName=='' || data.roleName==null) ? '--' : getDisplayRole(data.roleName)}
                      </td>

                      <td>
                        {(data.status=='' || data.status==null) ? '--' : getDisplayStatus(data.status)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

        </div>

                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 
                 {/* <small>Max 3 Categories</small> */}
                 <div className="row mt-8">


                     <div className="divider"></div>
                 
                  <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Merge Companies </button>
                 
                 
                 </div>

                

                 </div>

                 <div id="mergecompanysuccessMessage" className="alert alert-success" role="alert">
                 Company {companyName} successfully merged with {destcompanyName}.
                  </div>
                 <div id="mergecompanyfailMessage" className="alert alert-danger" role="alert">Please try again</div>
                 <div id="mergecompanyfailMessageDuplicate" className="alert alert-danger" role="alert">Source and destination must not be the same.</div>
                                           
              </div>
                 </div>

               </div>
             </div>
</form>
        </>
      )
    }
export {Mergewithcompany}